<template>
    <div class="seat-viewer__page" id="content" v-if="result">

        <!-- Intro Section -->
        <div class="intro__holder background-image-holder intro__holder--seat-viewer ">
            <div class="wrapper">
                <intro-component 
                    :intro="result.seatViewer.data.attributes.Intro" 
                    :isCover="true" 
                    :isAnimated="true"
                ></intro-component>
            </div>

            <span class="seat-viewer-background">
            </span>
            <div class="medium-wrapper seat-viewer__wrapper">
            <!-- Responsive Images Section -->
                <div class="seat-viewer__images">
                    <!-- Desktop Image -->
                    <div class="seat-viewer__image seat-viewer__image--desktop">
                        <SafeImage 
                            v-if="result.seatViewer.data.attributes.DesktopImage"
                            :imageData="result.seatViewer.data.attributes.DesktopImage"
                            placeholderText="Desktop image not available"
                            imageClass="seat-viewer-desktop-image"
                            loading="lazy"
                        />
                    </div>

                    <!-- Tablet Image -->
                    <div class="seat-viewer__image seat-viewer__image--tablet">
                        <SafeImage 
                            v-if="result.seatViewer.data.attributes.TabletImage"
                            :imageData="result.seatViewer.data.attributes.TabletImage"
                            placeholderText="Tablet image not available"
                            imageClass="seat-viewer-tablet-image"
                            loading="lazy"
                        />
                    </div>

                    <!-- Mobile Image -->
                    <div class="seat-viewer__image seat-viewer__image--mobile">
                        <SafeImage 
                            v-if="result.seatViewer.data.attributes.MobileImage"
                            :imageData="result.seatViewer.data.attributes.MobileImage"
                            placeholderText="Mobile image not available"
                            imageClass="seat-viewer-mobile-image"
                            loading="lazy"
                        />
                    </div>
                    <span class="seat-viewer__image__icon ticket">
                        <ticket-icon/>
                    </span>
                    <span class="seat-viewer__image__icon rotation">
                        <rotation-icon/>
                    </span>
                    <div class="seat-viewer__image__tooltip">
                        <p>
                            Fans select a section to enter the 3D experience.
                        </p>
                    </div>
                </div>
            </div>

            <!-- Helping Fans Section -->
            <div class="seat-viewer__helping-fans" v-if="result.seatViewer.data.attributes.HelpingFans">
                <div class="small-wrapper">
                    <div class="helping-fans__content grid two">
                        <h2 v-if="result.seatViewer.data.attributes.HelpingFans.title">
                            {{ result.seatViewer.data.attributes.HelpingFans.title }}
                        </h2>
                        <div class="helping-fans__content__right">
                            <p v-if="result.seatViewer.data.attributes.HelpingFans.description" 
                            v-html="result.seatViewer.data.attributes.HelpingFans.description">
                            </p>
                            <p v-if="result.seatViewer.data.attributes.HelpingFans.smallerText" 
                            class="smaller-text">
                                {{ result.seatViewer.data.attributes.HelpingFans.smallerText }}
                            </p>
                            
                                                <!-- Button for Helping Fans section -->
                            <a v-if="result.seatViewer.data.attributes.HelpingFans.buttonText && result.seatViewer.data.attributes.HelpingFans.buttonUrl"
                            :href="result.seatViewer.data.attributes.HelpingFans.buttonUrl" 
                            :target="result.seatViewer.data.attributes.HelpingFans.buttonIsExternal ? '_blank' : '_self'"
                            :rel="result.seatViewer.data.attributes.HelpingFans.buttonIsExternal ? 'noopener noreferrer' : undefined">
                                <span>
                                    <arrow-right/>
                                </span>
                                {{result.seatViewer.data.attributes.HelpingFans.buttonText}}
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <span class="contact-noise"/>
            <span class="seat_viewer_background"/>

        </div>

        <!-- Flex Content Section -->
        <div class="content" v-if="result.seatViewer.data.attributes.flexContent && result.seatViewer.data.attributes.flexContent.length > 0">
            <div class="flex__element" v-for="(component, index) in result.seatViewer.data.attributes.flexContent" :key="index">
                <component :is="`flex-${component.__typename}`" :componentData="component"/>
            </div>
        </div>

        <!-- Hire Us Section -->
        <div class="seat-viewer__hireus marquee__holder hire-us__holder background-image-holder">
            <div class="wrapper">
                <intro-component 
                    :intro="result.seatViewer.data.attributes.HireUs" 
                    :isAnimated="true"
                ></intro-component>

                <contact-form-with-company 
                    type="seatViewer"
                    gsap-animation="fadeIn"
                    gsap-delay="0.3"
                    gsap-duration="0.2"
                    gsap-ease="none">
                </contact-form-with-company>
            </div>

            <div class="marquee">
                Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/Work with us/
            </div>

            <span class="contact-noise"></span>
            
            <span class="contact-background">
            </span>
        </div>

        <!-- SEO Component -->
        <Seo 
            v-if="result.seatViewer.data.attributes.seo" 
            :seoData="result.seatViewer.data.attributes.seo"
        />

    </div>
</template>

<script lang="ts">

    import { defineComponent, ref, watch } from 'vue'
    import gql from 'graphql-tag'

    import { useQuery } from '@vue/apollo-composable'
    import { SEAT_VIEWER_QUERY } from '../graphql/seat-viewer'

    import IntroComponent from '../components/IntroComponent.vue'
    import SafeImage from '../components/SafeImage.vue'
    import ButtonComponent from '../components/ButtonComponent.vue'
    import ContactFormWithCompany from '../components/ContactFormWithCompany.vue'
    import ArrowRight from '../components/svg/ArrowRight.vue'
    import TicketIcon from '../components/svg/TicketIcon.vue'
    import RotationIcon from '../components/svg/RotationIcon.vue'
    import Seo from '../components/navigation/Seo.vue'

    import FlexComponentContentVideo                from "../components/flex-content/Video.vue"
    import FlexComponentContentGridImages           from "../components/flex-content/GridImages.vue"
    import FlexComponentContentImageCarousel        from "../components/flex-content/ImageCarousel.vue"
    import FlexComponentContentLargeFact            from "../components/flex-content/LargeFact.vue"
    import FlexComponentContentQuote                from "../components/flex-content/Quote.vue"
    import FlexComponentContentSingleImage          from "../components/flex-content/SingleImage.vue"
    import FlexComponentContentThreeColumnsFacts    from "../components/flex-content/ThreeColumnsFacts.vue"
    import FlexComponentContentTwoColumns           from "../components/flex-content/TwoColumns.vue"
    import FlexComponentContentTwoColumnsFacts      from "../components/flex-content/TwoColumnsFacts.vue"
    import FlexComponentContentTwoColumnsText       from "../components/flex-content/TwoColumnsText.vue"
    import FlexComponentContentWebsiteCta           from "../components/flex-content/WebsiteCta.vue"
    import FlexComponentContentQuoteSmall           from "../components/flex-content/QuoteSmall.vue"
    import FlexComponentContentContentIntro         from "../components/flex-content/ContentIntro.vue"
    import FlexComponentContentFourCards            from "../components/flex-content/FourCards.vue"
    import FlexComponentContentTrustedBy            from "../components/flex-content/TrustedBy.vue"
    import FlexComponentContentThreeColumnCards     from "../components/flex-content/ThreeColumnCards.vue"

    export default defineComponent({
        components: {
            IntroComponent,
            SafeImage,
            ButtonComponent,
            ContactFormWithCompany,
            ArrowRight,
            TicketIcon,
            RotationIcon,
            Seo,
            FlexComponentContentVideo,
            FlexComponentContentGridImages,
            FlexComponentContentImageCarousel,
            FlexComponentContentLargeFact,
            FlexComponentContentSingleImage,
            FlexComponentContentThreeColumnsFacts,
            FlexComponentContentTwoColumns,
            FlexComponentContentTwoColumnsFacts,
            FlexComponentContentTwoColumnsText,
            FlexComponentContentWebsiteCta,
            FlexComponentContentQuote,
            FlexComponentContentQuoteSmall,
            FlexComponentContentContentIntro,
            FlexComponentContentFourCards,
            FlexComponentContentTrustedBy,
            FlexComponentContentThreeColumnCards,
        },

        setup() {
            const homeurl: string = import.meta.env.VITE_API_URL

            const seat_viewer_query = ref(SEAT_VIEWER_QUERY)
            
            const { result, loading } = useQuery(seat_viewer_query)
            
            // Track when query completes
            watch([result, loading], ([newResult, newLoading]) => {
                if (!newLoading && newResult) {
                    console.log('Seat Viewer data loaded:', newResult)
                }
            })

            return {
                result,
                homeurl
            }
        },
    })
</script>
